import Menu from '@component/menu'
import ShareFacebook from '@component/share/facebook'
import ShareTwitter from '@component/share/twitter'
import ShareLinkedin from '@component/share/linkedin'
import ShareLink from '@component/share/link'
// import ShareEmail from '@component/share/email'

export default function ReviewShareButton() {

  const shareMenu = [
    <ShareFacebook key='facebook'></ShareFacebook>,
    <ShareTwitter key='twitter'></ShareTwitter>,
    <ShareLinkedin key='linkedin'></ShareLinkedin>,
    <ShareLink key='link'></ShareLink>,
    // <ShareEmail key='emial'></ShareEmail>
  ]

  return (
    <Menu right data={shareMenu} width={80} contentClassName='flex flex-col items-center justify-start py-20 space-y-30'>
      <button type='button' className='button-primary-out rounded-[32px]'>
        <i className='icon icon-share !text-xl'></i>
        <span className='ml-10 text-sm'>Share</span>
      </button>
    </Menu>
  )
}